import { createContext } from 'react';

import type { HubConnection, HubConnectionState } from '@microsoft/signalr';

export const SignalRConnectionContext = createContext<{
  connection: HubConnection;
  state: HubConnectionState;
} | null>(null);
